/**
 * Удаление сущностей
 */

import { apiFetch } from "../api-fetch";
import Toast from "../../components/modal/toast";
import { triggerEvent } from "../helpers/trigger-event";

document.addEventListener("click", e => {
  
  let deleter = e.target.closest('[data-delete]');
  if (!deleter) return;
  
  let deleteUrl = deleter.dataset.action;
  if (!deleteUrl) return;

  let deleteToken = deleter.dataset.token;

  const question = deleter.dataset.question || 'Подтвердите удаление';
  const confirmButton = deleter.dataset.confirmButton || 'Удалить';

  window.confirm({
    question: question,
    confirmButton: confirmButton
  })
  .then(() => {
    let data = new FormData();

    if (deleteToken) {
      data.append("token", deleteToken);
    }

    apiFetch(deleteUrl, {
      method: "POST",
      body: data
    })
    .then(response => {
      if (response.success) {
        if (response.redirectUrl) {
          window.location.href = response.redirectUrl;
          return;
        }

        let item = deleter.closest('[data-delete-item]');
        if (!item) return;

        if (item.hasAttribute('data-delete-redirect')) {
          location = item.getAttribute('data-delete-redirect');
        } else if (item.hasAttribute('data-delete-remove')) {
          triggerEvent(item, "delete");
          item.remove();
        }
      }
    })
    .catch(error => {
      Toast.open(error, {
        state: "error"
      });
      console.error(error);
    });
  })
  .catch((err) => {
    console.error(err)
  })

  

})